/**
 * @generated SignedSource<<3c547f5b2e0abd63618df960a2af5833>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserColumn_TreeStateFragment$data = {
  readonly user: {
    readonly " $fragmentSpreads": FragmentRefs<"ProjectUserDescription_UserFragment">;
  } | null | undefined;
  readonly " $fragmentType": "UserColumn_TreeStateFragment";
};
export type UserColumn_TreeStateFragment$key = {
  readonly " $data"?: UserColumn_TreeStateFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserColumn_TreeStateFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserColumn_TreeStateFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProjectUserDescription_UserFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TreeState",
  "abstractKey": null
};

(node as any).hash = "e3ab9b4d086f96b390aeb2cbc44dd9b8";

export default node;
